module.exports = __webpack_public_path__ + "static/logosquare-0d35deb0965e7cd07343cc32cdc87c2f.svg";